/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';

/**
 * # SPECIAL NOTE
 * In the interest of proper tree shaking and keeping the bundle size down, I've commented out everything in this file
 * since material is not currently in use, the expectation going forward will be to uncomment things as you use them.
 */

// CDK modules
// import { A11yModule } from '@angular/cdk/a11y';
// import { ClipboardModule } from '@angular/cdk/clipboard';
import { DragDropModule } from '@angular/cdk/drag-drop';
// import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
// import { CdkStepperModule } from '@angular/cdk/stepper';
// import { CdkTableModule } from '@angular/cdk/table';
// import { CdkTreeModule } from '@angular/cdk/tree';
// form controls
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatPseudoCheckboxModule } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
// import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
// navigation
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
// layout
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatListModule } from '@angular/material/list';
// import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
// import { MatTreeModule } from '@angular/material/tree';
// buttons and indicators
import { MatButtonModule } from '@angular/material/button';
// import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatBadgeModule } from '@angular/material/badge';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
// import { MatProgressBarModule } from '@angular/material/progress-bar';
// import { MatRippleModule } from '@angular/material/core';
// popups and dialogs
// import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
// table
// import { MatPaginatorModule } from '@angular/material/paginator';
// import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

// for svg icon registration
import { DomSanitizer } from '@angular/platform-browser';

const AllMaterialModules = [
	// A11yModule,
	// ClipboardModule,
	// CdkStepperModule,
	// CdkTableModule,
	// CdkTreeModule,
	DragDropModule,
	// PortalModule,
	ScrollingModule,
	MatAutocompleteModule,
	MatCheckboxModule,
	MatDatepickerModule,
	MatFormFieldModule,
	MatInputModule,
	MatRadioModule,
	MatSelectModule,
	// MatSliderModule,
	MatSlideToggleModule,
	MatMenuModule,
	MatSidenavModule,
	MatToolbarModule,
	MatCardModule,

	MatDividerModule,
	MatExpansionModule,
	MatGridListModule,
	MatListModule,
	// MatStepperModule,
	MatTabsModule,
	// MatTreeModule,
	MatButtonModule,
	// MatButtonToggleModule,
	MatBadgeModule,
	MatChipsModule,
	MatIconModule,
	MatProgressSpinnerModule,
	// MatProgressBarModule,
	// MatRippleModule,
	// MatBottomSheetModule,
	MatDialogModule,
	MatSnackBarModule,
	MatTooltipModule,
	// MatPaginatorModule,
	// MatSortModule,
	MatTableModule,
	MatPseudoCheckboxModule,
];

@NgModule({
	imports: [...AllMaterialModules],
	exports: [...AllMaterialModules],
	providers: [{ provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } }],
})
export class MaterialModule {
	// registering svg icons for material here
	constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
		//Desktop icons
		iconRegistry.addSvgIcon(
			'scheduling',
			sanitizer.bypassSecurityTrustResourceUrl('assets/images/project-schedule-icon.svg')
		);

		//Mobile icons
		iconRegistry.addSvgIcon(
			'filter_alt_on',
			sanitizer.bypassSecurityTrustResourceUrl('assets/images/filter_alt_on.svg')
		);
	}
}
